import { forwardRef, useState } from "react";
import WPInput, { WPRangedInput } from "../../packages/WPInput";
import styles from "./WPInputTooltipError.module.scss";
import { InputErrorIcon } from "../../packages/SVGs";


const WPInputTooltipError = forwardRef(({ onValidationError, tooltipPlacement = "top", ...rest }, ref) => {
  const [errMsg, setErrMessage] = useState("");
  const [isHovered, setIsHovered] = useState(false);

  const handleValidationError = (error, id, testId) => {
    setErrMessage(error);
    onValidationError?.(error, id, testId);
  };

  const tooltipClass = `${styles["wp-input-tooltip-error-tooltip"]} ${styles[`placement-${tooltipPlacement}`]}`;

  return (
    <div
      className={styles["wp-input-tooltip-error-container"]}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {errMsg && isHovered && (
        <div className={tooltipClass}>
          <span className={styles.error}>
            <InputErrorIcon />
          </span>
          {errMsg}
        </div>
      )}
      {rest.type === "text" ? (
        <WPInput {...rest} onValidationError={handleValidationError} />
      ) : (
        <WPRangedInput {...rest} hideRangeAlways onValidationError={handleValidationError} ref={ref} />
      )}
    </div>
  );
});
WPInputTooltipError.displayName = "WPInputTooltipError";
export default WPInputTooltipError;
